import type { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { Tag as XingTag } from '@xing-com/tag';
import { spaceM } from '@xing-com/tokens';

export interface IProps {
  children: ReactNode;
}

const StyledXingTag = styled(XingTag)`
  display: inline-flex;
  margin-bottom: ${spaceM};
  margin-right: ${spaceM};
  user-select: auto;
  pointer-events: none;
`;

export const Tag: FC<IProps> = ({ children }) => (
  <StyledXingTag>{children}</StyledXingTag>
);
